<div class="flex layout-column address-point-column">
  <div class="time-label address-point-label text-ellipsis"
       [title]="label">{{ label }}</div>
  <div class="layout-row layout-align-start-center address-point-row">
    <bringoz-button type="tertiary"
                    [ngbTooltip]="'Home Address' | translate"
                    openDelay="300"
                    triggers="hover"
                    container="body"
                    (onClick)="onPointTypeChange.emit(locationTypeCustom)">
      <bringoz-icon iconName="home"
                    [fill]="pointType === locationTypeCustom ? '#007bff' : '#A3A3A3'">
      </bringoz-icon>
    </bringoz-button>
    <bringoz-button type="tertiary"
                    [ngbTooltip]="'Location' | translate"
                    openDelay="300"
                    triggers="hover"
                    container="body"
                    (onClick)="onPointTypeChange.emit(servicePointType)">
      <bringoz-icon iconName="business"
                    [fill]="pointType === servicePointType ? '#007bff' : '#A3A3A3'">
      </bringoz-icon>
    </bringoz-button>
    <bringoz-button type="tertiary"
                    [ngbTooltip]="'Custom Address' | translate"
                    openDelay="300"
                    triggers="hover"
                    container="body"
                    (onClick)="onPointTypeChange.emit(customAddressType)">
      <bringoz-icon iconName="location-pin-outline"
                    [fill]="pointType === customAddressType ? '#007bff' : '#A3A3A3'">
      </bringoz-icon>
    </bringoz-button>
    <bringoz-icon class="point-types-info"
                  iconName="info-outline"
                  classSize="md"
                  fill="#0000008a"
                  [ngbTooltip]="pointTypesInfoTooltip"
                  tooltipClass="availability-point-types-tooltip"
                  placement="auto"
                  openDelay="300"
                  triggers="hover"
                  container="body">
    </bringoz-icon>
    <div *ngIf="pointType === locationTypeCustom"
         class="flex address-display br-body-2 gray-101 text-ellipsis">
      <span>{{ homeDisplay }}</span>
      <span *ngIf="!homeDisplay" translate>Home address</span>
    </div>
    <app-service-point-select *ngIf="pointType === servicePointType"
                              class="flex service-point-select"
                              [selectedId]="servicePointId"
                              [selectedPlace]="servicePointPlace"
                              (onChange)="onServicePointChange.emit($event.servicePoint)">
    </app-service-point-select>
    <app-address-autocomplete-input *ngIf="pointType === customAddressType"
                                    class="flex custom-address-input"
                                    [address]="customAddress"
                                    (onChange)="onCustomAddressChange.emit($event)">
    </app-address-autocomplete-input>
  </div>
</div>

<ng-template #pointTypesInfoTooltip>
  <div class="layout-column gap-5 point-types-tooltip-content">
    <span><span class="font-weight-600">{{ 'Home Address' | translate }}:</span> {{ "Pulls the agent's configured address from their profile in the site." | translate }}</span>
    <span><span class="font-weight-600">{{ 'Location' | translate }}:</span> {{ 'Uses a predefined location configured in the site.' | translate }}</span>
    <span><span class="font-weight-600">{{ 'Custom Address' | translate }}:</span> {{ "Allows entering any custom address for the agent's start/end point." | translate }}</span>
  </div>
</ng-template>
